import { Grid, Typography } from '@mui/material';
import { UploadCsv } from '@/icons';

const UploadButton = ({ hover,text }: any) => {
  return (
    <Grid
      sx={{
        display: 'flex',
        padding: '12px 32px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '8px',
        borderRadius: '4px',
        border: '1px solid var(--gray-300, #E6E6E6)',
        background: '#FFF',
        cursor: 'pointer'
      }}
      className='upload-btn'
    >
      <UploadCsv fill={hover ? '#175CE5' : '#333333'} />
      <Typography
        sx={{
          color: hover ? '#175CE5' : 'var(--gray-6-darker, #333)',
          fontFamily: 'Poppins',
          fontSize: '12px',
          fontStyle: 'normal',
          fontWeight: 600,
          lineHeight: '24px'
        }}
      >
        {text}
      </Typography>
    </Grid>
  );
}

export default UploadButton; 